<script lang="ts">
  import { editingMode, features, projectStore } from '@dabble/app';
  import { Doc } from '@dabble/data/types';
  import EditableContent from '@dabble/toolkit/EditableContent.svelte';
  import CastItem from './CastItem.svelte';
  import FolderItem from './FolderItem.svelte';

  export let doc: Doc;
  export const backgroundColor = 'var(--folder-background)';
  $: children = $projectStore.childrenLookup[doc.id] || [];
  $: readonly = !$features.has('story_notes') || $editingMode === 1;
</script>

<div data-id={doc.id} class="folder-view">
  <EditableContent {doc} class="folder-title centered" field="title" header="h1" {readonly} />
  <div class="children">
    {#each children as child}
      {#if child.type === 'novel_character' || 'bannerUrl' in child}
        <CastItem doc={child} />
      {:else}
        <FolderItem doc={child} />
      {/if}
    {/each}
  </div>
</div>

<style>
  .folder-view {
    position: relative;
    background: var(--folder-background);
  }
  .folder-view :global(.folder-title h1) {
    margin: 0;
    padding: 3rem 0.5rem;
    color: var(--text-color-light);
    text-shadow: var(--text-highlight);
    text-align: center;
  }
  .children {
    margin-top: 1rem;
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    justify-content: center;
    gap: 1rem;
  }
</style>
